module.exports = __webpack_public_path__ + "img/camping-5.7c61231a.jpg";